export default "__VITE_ASSET__707186a3__"